import { IconButton, Stack, Badge, Popover, Box, TextField, MenuItem } from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useEffect, useState } from "react";
import apiCNP from "../services/apiCNP";


export default function ProvinciaFilter(props) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [provincias, setProvincias] = useState([]);
  const open = Boolean(anchorEl);

  const [openSelect, setOpenSelect] = useState(true);

  const onClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    apiCNP.get('/provincias')
      .then(res => {
        setProvincias(res?.data?.provincias);
      }).catch(err => console.error(err));

  }, []);

  //  FILTRA O ID DA PROVINCIA SELECIONADA PARA SER USADO NO FILTRO DE MUNICIPIOS
  useEffect(() => {
    if (props?.provincia && props?.setProvinciaId) {
      const provinciaSelecionada = provincias.find(p => p.designacao === props.provincia);
      if (provinciaSelecionada) {
        props?.setProvinciaId(provinciaSelecionada._id);
      } else {
        props?.setProvinciaId("");
      }
    } else {
      // props?.setProvinciaId("");
    }
  }, [props?.provincia]);

  return (
    <Stack direction="row" alignItems="center" spacing={0.5}>
      <IconButton
        size="small"
        htmlFor="provincia-select"
        onClick={(e) => {
          setAnchorEl(e.currentTarget);
          setOpenSelect(!openSelect);
        }}
      >
        <Badge
          color="primary"
          variant="dot"
          invisible={!props.provincia}
        >
          <FilterListIcon fontSize="small" />
        </Badge>
      </IconButton>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={onClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Box p={2} minWidth={220}>
          <TextField
            type="text"
            label="Filtro por provincia"
            select
            style={{ width: 200 }}
            size="small"
            name="provincia"
            variant="outlined"
            onChange={(e) => {
              props.setProvincia(e.target.value === "Geral" ? "" : e.target.value);
            }
            }
            SelectProps={{
              open: openSelect,
              onOpen: () => setOpenSelect(true),
              onClose: () => setOpenSelect(false),
            }}
            value={props.provincia}
          >
            <MenuItem value="Geral">Geral</MenuItem>
            {provincias?.map((provincia) => (
              <MenuItem key={provincia._id} value={provincia?.designacao} >
                {provincia.designacao}
              </MenuItem>
            ))}
          </TextField>
        </Box>
      </Popover>
    </Stack>
  );
};


